module.exports = __webpack_public_path__ + "static/img/a1.8c8fe1d5.png";